import React from 'react'
import { A, Text } from '@rebrandly/styleguide'

import './InfoBoxes.css'

const InfoBoxes = () => {
  return (
    <div className='InfoBoxes'>
      <div className='InfoBoxes__container container'>
        <div className='InfoBoxes__box'>
          <div className='InfoBoxes__box-title--small-screen'>
            <Text size='3x-large'>A fast, easy, and free link shortener</Text>
          </div>
          <div className='InfoBoxes__box-title--large-screen'>
            <Text size='3x-large'>A fast, easy, and free<br />link shortener</Text>
          </div>
          <Text size='medium'>Use this free URL shortener to change long, ugly links into memorable and trackable short
            URLs. <A size='x-lg' href='https://rb.gy'>RB.GY</A> is the best free link shortener alternative to Bitly,
            Tinyurl, and Google link shorteners.</Text>
        </div>
        <div className='InfoBoxes__box'>
          <div className='InfoBoxes__box-title--small-screen'>
            <Text size='3x-large'>Shorten links, then track them</Text>
          </div>
          <div className='InfoBoxes__box-title--large-screen'>
            <Text size='3x-large'>Shorten links,<br/>then track them</Text>
          </div>
          <Text size='medium'>Free short links for any social media platform, website, SMS, email, ads, and more.
            Generate short links for Instagram, LinkedIn, Facebook, X, TikTok and more.<br />Turn short links into QR codes
            with our <A size='x-lg' href='/qr-code-generator'>free QR code generator</A>.</Text>
        </div>
      </div>
    </div>
  )
}

export default InfoBoxes
